<template>
  <div>
    <p v-if="enteredAt" class="notification_label">Lead has been in {{ notification.data.status_label }} status since {{ enteredAt }}</p>
    <p v-else class="notification_label">Lead has been in {{ notification.data.status_label }} status</p>
    <button-link @click="goToLead">{{ notification.data.record_address }}</button-link>
  </div>
</template>

<script>
import router from "../../../router";
import dates from "../../../services/dates";
import api from "../../../api";

/**
 * NOTE: The if statement above is added because the forwarder_label was just added to data in Jan 2023,
 * and we need to support notifications that don't have it yet.
 */
export default {
  name: "RecordInStatusXTimeReminderNotification",
  props: {
    notification: Object
  },
  computed: {
    enteredAt() {
      if (this.notification.data.hasOwnProperty('created_at')) {
        return dates.formatAsDateTime(this.notification.data.created_at)
      }
      return null
    }
  },
  methods: {
    goToLead() {
      api.notifications.markRead({ notification_id: this.notification.id }).then(() => {
        // NOTE: The database read_at will be different from now, but read_at just needs a date
        // in order for this to work. We don't show the read at time.
        this.notification.read_at = dates.getNowISO()
      })
      router.replace({query: {lead: this.notification.data.record_id}});
    },
  },
}
</script>

<style lang="scss" scoped>
.notification_label {
  margin-bottom: 2px;
  font-size: 0.875rem;
}
</style>
